import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import {AddNewComment, CommentsList} from './';
import React, {Component, PropTypes} from 'react';

class CommentsSection extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  render() {
    const {lessonId} = this.props.params;

    return (
      <div className="community-comments-container">
        <div className="community-comments-title">CONVERSATIONS</div>
        <AddNewComment lessonPlanId={lessonId} />
        <CommentsList lessonPlanId={lessonId} />
      </div>
    );
  }
}

CommentsSection.propTypes = {
  params: PropTypes.object.isRequired,
};

export default withRouter(connect()(CommentsSection));



// WEBPACK FOOTER //
// ./app/features/comments/components/CommentsSection.js